module.exports = __webpack_public_path__ + "img/sofi-stadium_exterior.cb727ef9.jpg";